import { Tooltip } from 'primereact/tooltip';
import { useCallback, useContext, useEffect, useRef } from 'react';
import { LayoutContext } from './context/layoutcontext';
import { MenuProvider } from './context/menucontext';
import type { MenuProps, MenuModel, Breadcrumb, BreadcrumbItem } from '../../Models/Template/index';
import AppMenuItem from './AppMenuitem';

const AppSubMenu = (props: MenuProps) => {
    const { setBreadcrumbs } = useContext(LayoutContext);
    const tooltipRef = useRef<Tooltip | null>(null);

    const generateBreadcrumbs = useCallback((model: MenuModel[]) => {
        const breadcrumbs: Breadcrumb[] = [];

        const getBreadcrumb = (item: BreadcrumbItem, labels: string[] = []) => {
            const { label, to, items } = item;

            if (label) {
                labels.push(label);
            }
            if (items) {
                items.forEach((_item: BreadcrumbItem) => {
                    getBreadcrumb(_item, labels.slice());
                });
            }
            if (to) {
                breadcrumbs.push({ labels, to });
            }
        };

        model.forEach((item) => {
            getBreadcrumb(item);
        });
        setBreadcrumbs(breadcrumbs);
    },[setBreadcrumbs]);

    useEffect(() => {
        generateBreadcrumbs(props.model);
    }, [generateBreadcrumbs, props.model]);


    return (
        <MenuProvider>
            <ul className="layout-menu">
                {props.model.map((item : MenuModel, i : number) => {
                    return !item.seperator ? <AppMenuItem item={item} root={true} index={i} key={item.label} /> : <li className="menu-separator"></li>;
                })}
            </ul>
            <Tooltip ref={tooltipRef} target="li:not(.active-menuitem)>.tooltip-target" />
        </MenuProvider>
    );
};

export default AppSubMenu;
